module.exports = __webpack_public_path__ + "static/img/icon_4.226a43fb.png";